

//@ts-ignore
import $i18n from '@/i18n';
import React from 'react';
import DarkToolTip from '../../../../../components/DarkToolTip';
import { formatTime } from '@/utils';



const tipRenderCell = (v, i, record) => <DarkToolTip trigger={['click']} placement="topLeft" arrow={{ pointAtCenter: true }} triggerContent={v} content={v} />



const baseStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: "2px 8px",
  fontWweight: 400,
  fontSize: "12px",
  letterSpacing: "0.2px",
  lineheight: "18px",
  borderRadius: "12px"

}
const tagRenderMap = {
  'AUTHED': {
    style: {
      color: "#00C76D",
      backgroundColor: "#EBFFF6"
    },
    text: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.tagRender.authed", dm: '审批通过' })
  },
  'IN_REVIEW': {
    style: {
      color: "#FF7E33",
      backgroundColor: "#FFF4ED"
    },
    text: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.tagRender.inReview", dm: '审核中' })
  },
  'REFUSED': {
    style: {
      color: 'rgb(253, 67, 64)',
      backgroundColor: 'rgb(255, 242, 242)',
    },
    text: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.tagRender.refused", dm: '已拒绝' })
  },
  'WITHDRAWN': {
    style: {
      color: "#585F7E",
      backgroundColor: "#F1F2F3"
    },
    text: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.tagRender.withdrawn", dm: '已撤回' })
  },
}

const dot = (color) => <div style={{
  width: 6, height: 6, borderRadius: 10, marginRight: 6, display: "inline-block",
  backgroundColor: color
}} />
const tagRenderCell = (v, i, record) => <div style={{ ...tagRenderMap[v]?.style, ...baseStyle }}>{dot(tagRenderMap[v]?.style?.color)}{tagRenderMap[v]?.text}</div>;


const handleFilters = (values) => {
  const filter: Array<{ label: string, value: string }> = [];
  for (const [key, value] of Object?.entries(values)) {
    filter?.push({ label: value as unknown as string, value: key });
  }
  return filter;
};

const channelFilters = (openJsApiAuthChannels) => handleFilters(openJsApiAuthChannels)


export const tableColumons = (openJsApiAuthChannels) => [
  {
    title: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.column.jsapiName", dm: '名称' }),
    dataIndex: 'jsapiName',
    width: 140,
    cell: tipRenderCell,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.functionDesc', dm: '描述' }),
    dataIndex: 'functionDesc',
    cell: tipRenderCell,
    width: 166,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.channelName', dm: '渠道' }),
    dataIndex: 'channelName',
    cell: tipRenderCell,
    width: 97,
    filters: channelFilters(openJsApiAuthChannels),
    filterMode: 'single',
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.supportSystem', dm: '支持的系统' }),
    dataIndex: 'supportSystem',
    width: 149,
    cell: (v) => v?.join(' / '),
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.status', dm: '状态' }),
    dataIndex: 'status',
    width: 149,
    cell: tagRenderCell,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.authedTime', dm: '授权时间' }),
    dataIndex: 'approveTime',
    width: 149,
    cell: (v) => v ? formatTime(v) : '-',
  }
];
